export const TITLE = "activation.homepage.widget.my_traffic_share.title";
export const TOOLTIP = "activation.homepage.widget.my_traffic_share.tooltip";

export const FOOTER_EMPTY = "activation.homepage.widget.my_traffic_share.set_up";
